import { QVueGlobals } from "quasar"

/**
 * Calls an async function with Quasar $q.loading.start() and $q.loading.stop() wrappers.
 * Ensures loading indicator is stopped even if the async function throws.
 *
 * @param fn - The async function to call
 * @param $q - The Quasar instance (must have $q.loading.start and $q.loading.stop)
 * @param args - Arguments to pass to the async function
 * @returns The result of the async function
 * @throws Rethrows any error from the async function
 */
export async function callWithLoading<T extends unknown[], R>(
   fn: (...args: T) => Promise<R>,
   $q: QVueGlobals,
   ...args: T
): Promise<R> {
   try {
      $q.loadingBar.start()
      const result = await fn(...args)
      return result
   } finally {
      $q.loadingBar.stop()
   }
}
